import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';

@Component({
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent {

  @ViewChild('dialogInstance', { static: false }) public dialog: ModalDirective;
  public actionSubscription: Subscription;
  public performingAsync: boolean = false;
  public errorMessage: string;
  public channel: Subject<boolean> = new Subject<boolean>();
  protected message: string = '';
  protected boldMessage: string = '';
  protected title: string = '';
  protected cancellationText = 'Cancel';
  protected confirmationText = 'Yes';

  public setMessage(message: string): void {
    this.message = message;
  }

  public setBoldMessage(boldMessage: string): void {
    this.boldMessage = boldMessage;
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public setCancellationText(text: string): void {
    this.cancellationText = text;
  }

  public setConfirmationText(text: string): void {
    this.confirmationText = text;
  }

  cancel(): void {
    this.channel.next(false);
  }

  confirm(): void {
    this.channel.next(true);
  }
}
